/**
 * 팝업 숨김 저장 (§11) — 팝업별 독립. localStorage(만료 내장) + sessionStorage(세션).
 *
 * 저장 키에 popup id + content_version + 만료를 포함하여, 팝업 버전이 오르면(관리자에서 콘텐츠 변경)
 * 기존 숨김 기록이 있어도 다시 노출된다. 만료된 기록은 재노출.
 */
interface HideRecord {
    v: number;        // content_version
    exp: number | null; // epoch ms, null = forever
}

const HIDE_PREFIX = "nlpopup:hide:";
const SESS_PREFIX = "nlpopup:sess:";
const VISITOR_KEY = "nlpopup:visited";

export class PopupStorage {
    static isHidden(id: number, version: number): boolean {
        try {
            const sraw = window.sessionStorage.getItem(SESS_PREFIX + id);
            if (sraw) {
                const s = JSON.parse(sraw) as HideRecord;
                if (s.v === version) return true;
                window.sessionStorage.removeItem(SESS_PREFIX + id);
            }
            const raw = window.localStorage.getItem(HIDE_PREFIX + id);
            if (raw) {
                const r = JSON.parse(raw) as HideRecord;
                // 버전 불일치 → 재노출(기록 폐기)
                if (r.v !== version) {
                    window.localStorage.removeItem(HIDE_PREFIX + id);
                    return false;
                }
                if (r.exp === null) return true;
                if (r.exp > Date.now()) return true;
                window.localStorage.removeItem(HIDE_PREFIX + id);
            }
        } catch {
            /* storage 불가(사생활 모드 등) → 숨기지 않음 */
        }
        return false;
    }

    static hide(id: number, version: number, policy: string, days: number): void {
        try {
            if (policy === "none") return;
            if (policy === "session") {
                window.sessionStorage.setItem(SESS_PREFIX + id, JSON.stringify({ v: version, exp: null }));
                return;
            }
            let exp: number | null = null;
            if (policy === "today") {
                const d = new Date();
                d.setHours(23, 59, 59, 999);
                exp = d.getTime();
            } else if (policy === "days") {
                exp = Date.now() + Math.max(1, days) * 86400000;
            } else if (policy === "forever") {
                exp = null;
            } else {
                return;
            }
            window.localStorage.setItem(HIDE_PREFIX + id, JSON.stringify({ v: version, exp }));
        } catch {
            /* noop */
        }
    }

    /** 재방문자 여부(§9). 최초 호출 시 방문 기록을 남기고 false 반환. */
    static isReturningVisitor(): boolean {
        try {
            const seen = window.localStorage.getItem(VISITOR_KEY);
            if (!seen) {
                window.localStorage.setItem(VISITOR_KEY, String(Date.now()));
                return false;
            }
            return true;
        } catch {
            return false;
        }
    }
}
